const markers = document.querySelectorAll('.map .marker');

if (markers.length > 0) {
    const mobileInfo = document.querySelector('.mobile-info');

    function moveInfo(info, originalParent) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
            mobileInfo.appendChild(info);
        } else {
            originalParent.appendChild(info);
        }
    }

    markers.forEach((marker) => {
        const info = marker.querySelector('.marker-info');
        if (!info) {
            return;
        }

        const originalParent = info.parentElement;

        marker.addEventListener('click', function () {
            markers.forEach((m) => {
                m.classList.remove('active');
                const mInfo = m.querySelector('.marker-info');
                if (mInfo) {
                    mInfo.classList.remove('active');
                }
            });

            const mobileInfoChildren = mobileInfo.querySelectorAll('.marker-info');
            mobileInfoChildren.forEach((mInfo) => {
                mInfo.classList.remove('active');
            });

            this.classList.add('active');
            info.classList.add('active');

            moveInfo(info, originalParent);
        });
    });

    function handleResize() {
        const activeMarker = document.querySelector('.map .marker.active');
        if (activeMarker) {
            const info = activeMarker.querySelector('.marker-info') || mobileInfo.querySelector('.marker-info.active');
            if (info) {
                moveInfo(info, activeMarker);
            }
        }
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('load', handleResize);
}
